<section>
    <div class="scroll-container">
        <div nz-row>
            <div nz-col nzSpan="18">
                <div class="heading-fs-18 mb-0">
                    <span nz-icon nzType="arrow-left" nzTheme="outline" class="drawer-back-arrow mr-2 disp-mob"
                        (click)="cancel()"></span>
                    {{ scheduleName || 'Schedule' }} Events
                </div>
            </div>
            <div nz-col nzSpan="6" class="text-right pt-2 disp-web">
                <span nz-icon nzType="close" nzTheme="outline" class="cursor-pointer" (click)="cancel()"></span>
            </div>
            <div nz-col nzSpan="24">
                <nz-divider></nz-divider>
            </div>
        </div>

        <div nz-row class="mb-3">
            <div nz-col nzSpan="12">
                <button nz-button nzType="default" type="button" [routerLink]="['/scheduler/create']" [queryParams]="{ scheduleId: schedulerId, scheduleName: scheduleName }">
                    <span nz-icon nzType="calendar" nzTheme="outline"></span>Go to Schedule
                </button>
            </div>
            <div nz-col nzSpan="12" class="text-right">
                <button nz-button nzType="primary" type="button" (click)="openEventDrawer()">
                    <span nz-icon nzType="plus" nzTheme="outline"></span>Add New Event
                </button>
            </div>
        </div>

        <nz-spin [nzSpinning]="isLoading">
            <div *ngIf="isModelLoaded && events && events.length > 0">
                <div nz-row *ngFor="let event of events; trackBy: trackByEventId" [nzGutter]="[16, 16]"
                    class="list-item mb-2 pt-2 pb-2">
                    <div nz-col nzSpan="24">
                        <div nz-row [nzGutter]="[8, 8]">
                            <div nz-col nzSpan="16">
                                <div class="d-flex align-items-start flex-column">
                                    <div class="mb-1">
                                        <strong>{{ event.name }}</strong>
                                    </div>
                                    <div class="text-muted fs-12 mb-1">
                                        <span nz-icon nzType="calendar" nzTheme="outline" class="mr-1"></span>
                                        {{ formatDate(event.startDate) }} - {{ formatDate(event.endDate) }}
                                    </div>
                                    <div class="mb-1">
                                        <nz-tag [nzColor]="getEventTypeBadgeColor(event)">
                                            {{ getEventTypeBadge(event) }}
                                        </nz-tag>
                                        <nz-tag *ngIf="event.eventType !== 1">
                                            <span nz-icon nzType="sync" nzTheme="outline" class="mr-1"></span>
                                            {{ formatRecurrence(event) }}
                                        </nz-tag>
                                    </div>
                                    <div *ngIf="event.description" class="text-muted fs-12">
                                        {{ event.description }}
                                    </div>
                                </div>
                            </div>
                            <div nz-col nzSpan="8" class="text-right align-items-center d-flex justify-content-end">
                                <span nz-icon nzType="edit" nzTheme="outline" 
                                    (click)="openEventDrawer(event)" 
                                    class="cursor-pointer mr-3 action-icon" 
                                    nz-tooltip="Edit Event"></span>
                                <span nz-icon nzType="delete" nzTheme="outline" 
                                    (click)="deleteEvent(event)" 
                                    class="cursor-pointer action-icon" 
                                    nz-tooltip="Delete Event"></span>
                            </div>
                        </div>
                    </div>
                    <nz-divider class="mt-1 mb-0"></nz-divider>
                </div>

                <!-- Pagination -->
                <div nz-row *ngIf="totalEvents > pageSize" class="mt-3">
                    <div nz-col nzSpan="24" class="text-center">
                        <nz-pagination 
                            [nzPageIndex]="currentPage" 
                            [nzTotal]="totalEvents" 
                            [nzPageSize]="pageSize"
                            (nzPageIndexChange)="onPageChange($event)">
                        </nz-pagination>
                    </div>
                </div>
            </div>

            <div *ngIf="isModelLoaded && (!events || events.length === 0)" class="empty-list-container">
                <nz-empty [nzNotFoundContent]="'No events found for this schedule'">
                    <div nz-empty-footer>
                        <button nz-button nzType="primary" (click)="openEventDrawer()">
                            <span nz-icon nzType="plus" nzTheme="outline"></span>Create First Event
                        </button>
                    </div>
                </nz-empty>
            </div>
        </nz-spin>

        <!-- Event Drawer for Add/Edit -->
        <nz-drawer #drawer [nzClosable]="false" nzPlacement="right" (nzOnClose)="close()" [nzMask]="false"
            class="custom-drawer">
            <ng-container *nzDrawerContent>
                <app-event-drawer 
                    #eventDrawer
                    [hidden]="!showEventDrawer"
                    [visible]="showEventDrawer"
                    [schedulerId]="schedulerId"
                    [groupId]="groupId"
                    [userId]="''"
                    (close)="closeEventDrawer($event)"
                    (save)="closeEventDrawer($event)">
                </app-event-drawer>
            </ng-container>
        </nz-drawer>
    </div>
</section>
